// Screenshots pasted into a session (backend/session_images.py). Each one is redrawn here before it's sent: at most
// 1568 px on its longer side (what Anthropic and OpenAI advise), PNG, or JPEG when the PNG would pass 2 MB. Redrawing
// also drops whatever the file carried besides the picture (camera data, location).
export const MAX_IMAGES = 4;
export const IMAGE_TYPES = ["image/png", "image/jpeg", "image/gif", "image/webp"];
const MAX_SIDE = 1568;
const MAX_BYTES = 2_000_000;

const blobOf = (canvas, type, quality) => new Promise((resolve) => canvas.toBlob(resolve, type, quality));

const dataOf = (blob) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(reader.result);
  reader.onerror = () => reject(reader.error);
  reader.readAsDataURL(blob);
});

// { url (to show it), data (base64, to send), media_type } for one image file
export async function prepareImage(file) {
  if (!IMAGE_TYPES.includes(file.type)) throw new Error("Only PNG, JPEG, GIF and WebP images can be sent.");
  const bitmap = await createImageBitmap(file);
  let scale = Math.min(1, MAX_SIDE / Math.max(bitmap.width, bitmap.height));
  for (;;) {
    const canvas = document.createElement("canvas");
    canvas.width = Math.max(1, Math.round(bitmap.width * scale));
    canvas.height = Math.max(1, Math.round(bitmap.height * scale));
    canvas.getContext("2d").drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    let blob = await blobOf(canvas, "image/png");
    if (blob.size > MAX_BYTES) blob = await blobOf(canvas, "image/jpeg", 0.85);
    if (blob.size <= MAX_BYTES || scale < 0.2) {
      if (blob.size > MAX_BYTES) throw new Error("This image is too large to send.");
      const url = await dataOf(blob);
      return { url, data: url.slice(url.indexOf(",") + 1), media_type: blob.type };
    }
    scale *= 0.75;
  }
}
